import { Link } from 'react-router-dom';

export default function PricingPreview() {
  return (
    <section className="bg-[#0f1628] geo-pattern py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Pricing</span>
          <h2 className="font-serif-jp text-white text-3xl md:text-4xl tracking-wider font-medium mb-4">料金プラン</h2>
          <div className="flex items-center justify-center gap-3">
            <div className="w-12 h-px bg-[#c9a84c]/40"></div>
            <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
            <div className="w-12 h-px bg-[#c9a84c]/40"></div>
          </div>
          <p className="text-white/40 text-sm tracking-wide mt-6 font-sans">
            お客様のニーズに合わせた柔軟なプランをご用意しております
          </p>
        </div>

        {/* Plan Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Personal */}
          <div className="border border-[#c9a84c]/30 p-8 md:p-10 hover:border-[#c9a84c] transition-all duration-300">
            <div className="inline-block border border-[#c9a84c] text-[#c9a84c] text-xs px-4 py-1 tracking-widest font-sans mb-6">
              PERSONAL
            </div>
            <h3 className="font-serif-jp text-white text-xl tracking-wider mb-2">個人事業主向けプラン</h3>
            <div className="flex items-end gap-2 my-6">
              <span className="font-cormorant text-[#c9a84c] text-5xl font-light">¥50,000</span>
              <span className="text-white/40 text-sm font-sans mb-2">〜 / 月額</span>
            </div>
            <div className="w-full h-px bg-[#c9a84c]/20 mb-6"></div>
            <ul className="flex flex-col gap-3 mb-8">
              {['基本コールセンター対応', '月間500件まで対応', 'メール・電話サポート', '月次レポート提供', '専任担当者アサイン'].map((f) => (
                <li key={f} className="flex items-center gap-3 text-white/60 text-xs font-sans">
                  <i className="ri-check-line text-[#c9a84c] text-sm flex-shrink-0"></i>
                  {f}
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="block text-center border border-[#c9a84c] text-[#c9a84c] py-3 text-xs tracking-widest font-sans hover:bg-[#c9a84c] hover:text-[#0f1628] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>

          {/* Business */}
          <div className="bg-[#c9a84c]/10 border border-[#c9a84c] p-8 md:p-10 relative">
            <div className="absolute top-0 right-0 bg-[#c9a84c] text-[#0f1628] text-xs px-4 py-1 tracking-widest font-sans font-medium">
              POPULAR
            </div>
            <div className="inline-block border border-[#c9a84c] text-[#c9a84c] text-xs px-4 py-1 tracking-widest font-sans mb-6">
              BUSINESS
            </div>
            <h3 className="font-serif-jp text-white text-xl tracking-wider mb-2">中小企業向けプラン</h3>
            <div className="flex items-end gap-2 my-6">
              <span className="font-cormorant text-[#c9a84c] text-5xl font-light">¥200,000</span>
              <span className="text-white/40 text-sm font-sans mb-2">〜 / 月額</span>
            </div>
            <div className="w-full h-px bg-[#c9a84c]/20 mb-6"></div>
            <ul className="flex flex-col gap-3 mb-8">
              {['フルコールセンター運営', '月間件数無制限', '24時間対応オプション', '週次・月次レポート', '複数担当者アサイン', 'SLA保証', 'カスタマイズ対応'].map((f) => (
                <li key={f} className="flex items-center gap-3 text-white/60 text-xs font-sans">
                  <i className="ri-check-line text-[#c9a84c] text-sm flex-shrink-0"></i>
                  {f}
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="block text-center bg-[#c9a84c] text-[#0f1628] py-3 text-xs tracking-widest font-sans font-medium hover:bg-[#e8c97a] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 text-[#c9a84c]/60 hover:text-[#c9a84c] text-xs tracking-widest font-sans transition-colors cursor-pointer whitespace-nowrap"
          >
            料金プランの詳細を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
